// @ts-strict-ignore
import React from 'react'
import connect from '@h/connect-redux'
import { getESProductDataSetData } from '@r/elasticsearch/elasticsearch-selectors'
import { brand } from '@r/app-selectors'
import get from '@u/get'
import { Logo } from './logo'
import { Button } from '../../../atoms'
import { FsCore } from '@t/fs-core'

export interface PpcNavProps {
  link: string
  jsonBody: any
  brand: string
}

export interface PpcProps {
  jsonBody: any
  dataset: any
}

const PpcNav = ({ link, jsonBody, brand }: PpcNavProps) => {
  const href = brand === 'money' ? 'https://www.money.co.uk' : 'https://www.uswitch.com'
  return (
    <div className='PpcNav'>
      <a href={href}>
        <Logo brand={brand} />
      </a>
      {jsonBody.text && (
        <Button size='sm' href={link} {...jsonBody.buttonProps}>
          {jsonBody.text}
        </Button>
      )}
    </div>
  )
}

export default connect((state: FsCore.State, props: PpcProps) => {
  let link

  if (props.jsonBody.text && props.dataset && props.jsonBody.link) {
    const datasetData = getESProductDataSetData(state, props.dataset.sys.id)?.hits?.hits
    link = get(datasetData?.[0], props.jsonBody.link)
  }

  return {
    ...props,
    link,
    brand: brand(state),
  }
})(PpcNav)
